<template>
  <section>
    <div class="b2c-button-section">
      <b-button class="b2c-btn" type="is-success" @click="showCouponModal('CREATE', null)">Create New</b-button>
    </div>

    <div>
      <b-table :data="couponsData || []" striped narrowed hoverable :checked-rows.sync="couponsData" searchable paginated
        pagination-simple pagination-position="bottom" sort-icon="arrow-up" sort-icon-size="is-small"
        default-sort-direction="asc" default-sort="code">
        <b-table-column field="code" label="Code" sortable searchable v-slot="props">
          <div>
            {{ props.row.code }}
          </div>
        </b-table-column>

        <b-table-column field="amount" sortable label="Amount" searchable v-slot="props">
          <div>
            {{ props.row.amount }}
          </div>
        </b-table-column>

        <b-table-column field="status" sortable label="Status" searchable v-slot="props">
          <span
            :class="'tag is-size-6 has-text-weight-medium' + (props.row.status == 'active' ? ' is-success' : ' is-danger')">
            {{ props.row.status }}
          </span>
        </b-table-column>

        <b-table-column field="redemptions" sortable label="Redemptions" searchable v-slot="props">
          <div>
            {{ props.row.redemptions }}
          </div>
        </b-table-column>

        <b-table-column field="startDate" sortable :custom-sort="sortByStartDate" label="Start Date" searchable
          v-slot="props">
          <div>
            {{ props.row.startDate }}
          </div>
        </b-table-column>

        <b-table-column field="expiryDate" sortable :custom-sort="sortByExpiryDate" label="Expiry Date" searchable
          v-slot="props">
          <div>
            {{ props.row.expiryDate }}
          </div>
        </b-table-column>

        <b-table-column v-slot="props">
          <div class="control-btns">
            <b-button class="ctrl-btn" type="is-text" outlined @click="downloadCSVData(props.row)">
              <i class="mdi mdi-download"></i>
            </b-button>
            <b-button class="ctrl-btn" type="is-text" outlined @click="showCouponModal('UPDATE', props.row)">
              <i class="mdi mdi-pencil"></i>
            </b-button>
          </div>
        </b-table-column>
      </b-table>
    </div>

    <b-modal :width="600" :can-cancel="true" v-model="isModalActive" :custom-class="'add-coupon-modal'">
      <add-coupon :action="modalAction" :payload="selectedCoupon"></add-coupon>
    </b-modal>

    <b-modal :width="600" :can-cancel="true" v-model="isViewCouponActive" :custom-class="'add-coupon-modal'">
      <view-coupon :payload="selectedCoupon"></view-coupon>
    </b-modal>
  </section>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import b2cAddNewCoupon from "./B2cAddCouponModal.vue";
import B2CViewCouponModal from "./B2CViewCouponModal.vue";
export default {
  components: {
    "add-coupon": b2cAddNewCoupon,
    "view-coupon": B2CViewCouponModal
  },
  data() {
    return {
      selectedCoupon: null,
      isModalActive: false,
      modalAction: "CREATE",
      isViewCouponActive: false
    }
  },
  computed: {
    ...mapGetters({
      coupons: "couponStore/allCoupons"
    }),
    couponsData() {
      return this.coupons.map(coupon => {
        // MUST UPDATE COUPON STATUS IN STORE
        return {
          name: coupon.name,
          code: coupon.code,
          status: moment(coupon.endDate).isAfter(moment()) ? 'active' : 'inactive',
          redemptions: coupon.redemptions.length,
          startDate: coupon.startDate ? moment(coupon.startDate).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY"),
          expiryDate: coupon.endDate ? moment(coupon.endDate).format("DD/MM/YYYY") : "No Expiry",
          amount: (coupon.amountType == 'fixed') ? `R ${this.formatPrice(coupon.amount)}` : `${coupon.amount} %`,
        }
      });
    }
  },
  async created() {
    await this.fetchCoupons();
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      fetchCoupons: "couponStore/fetchCoupons"
    }),
    showCouponModal(modalAction, couponPayload) {
      this.selectedCoupon = couponPayload ? this.coupons.find(coupon => coupon.code == couponPayload.code) : null;
      this.modalAction = modalAction;
      this.isModalActive = true;
    },
    showViewCouponModal(couponPayload) {
      this.selectedCoupon = couponPayload ? this.coupons.find(coupon => coupon.code == couponPayload.code) : null;
      this.isViewCouponActive = true;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    sortByExpiryDate(a, b, isAsc) {
      let aDate = a.expiryDate.split('/').reverse().join();
      let bDate = b.expiryDate.split('/').reverse().join();

      if (isAsc) {
        return moment(aDate) - moment(bDate);
      } else {
        return moment(bDate) - moment(aDate);
      }
    },
    sortByStartDate(a, b, isAsc) {
      let aDate = a.startDate.split('/').reverse().join();
      let bDate = b.startDate.split('/').reverse().join();

      if (isAsc) {
        return moment(aDate) - moment(bDate);
      } else {
        return moment(bDate) - moment(aDate);
      }
    },
    downloadCSVData(couponPayload) {
      this.selectedCoupon = couponPayload ? this.coupons.find(coupon => coupon.code == couponPayload.code) : null;
      let redemptions = this.selectedCoupon.redemptions;

      let data = [];

      redemptions.forEach(element => {
        let x = [element._id, element.userId, element.email, element.date];
        data.push(x);
      });
      // console.log(data);
      let csv = 'ID,UserId,Email,Redeemed Date\n';
      data.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });

      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'redemptions.csv';
      anchor.click();
    }
  }
}
</script>

<style lang="scss">
.control-btns {
  display: flex;
  flex-direction: row;

  .ctrl-btn {
    padding: 0.5rem 0.25rem;
    height: 2rem;
    font-size: 1.5rem;
    line-height: 1rem;

    &:first-child {
      margin-right: 0.5rem;
    }
  }
}

.b2c-button-section {
  margin-top: 1.3rem;
  margin-bottom: 2rem;

  .b2c-btn {
    background-color: #008871 !important;
    border-radius: 4rem;
    padding: 5px 40px;
  }
}

.add-coupon-modal {
  .animation-content {
    overflow-y: scroll !important;
  }
}
</style>